module.exports = __webpack_public_path__ + "static/media/BackgroundGAPI.e676ae43.png";